/**
 * Lightweight permissions store, populated once from the `/me` response after login.
 * Permission keys correspond 1:1 to Keycloak client roles on the BFF's OIDC client.
 * See doc/keycloak-rbac-setup.md (how to grant a role) and doc/roles.md (registry of
 * all permission keys implemented so far) for details.
 *
 * NOTE: this only controls what the UI shows. The BFF independently enforces the same
 * permissions on the API (see RadishDms.Bff.Authorization.PermissionClaims) — hiding a
 * button here is a UX nicety, not the security boundary.
 */

let _permissions: Set<string> = new Set();

export const PERMISSIONS_CHANGED_CHANNEL = 'radish:permissions:changed';

export function setPermissions(permissions: string[]): void {
  _permissions = new Set(permissions);
}

export function hasPermission(permission: string): boolean {
  return _permissions.has(permission);
}
